export default "__VITE_ASSET__9011f82d__"